var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"feedback-container"},[_c('div',{staticClass:"feedback-container-row"},[(_vm.showStartCountdown)?_c('StartSessionCountdown'):_vm._e(),(_vm.confirmPresentation)?_c('ConfirmPresentationMode'):_vm._e(),(_vm.streamEnabled)?_c('PublisherInternetStability'):_vm._e(),_c('ErrorDisplay'),_c('Toast')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }